import { Loading, Modal } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, PropsWithChildren, ReactNode, memo } from 'react';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  className?: string;
  onClose: () => void;
  open: boolean;
  text: string | ReactNode;
  icon?: ReactNode;
};

export const LoadingModal: FC<PropsWithChildren<Props>> = memo(
  ({ className, onClose, open, text, icon }) => {
    return (
      <Modal
        onClose={onClose}
        open={open}
        size='xs'
        isShowHeader={false}
        isShowFooter={false}
        isOutsideClose={false}
        isEscKeyClose={false}
        radius='medium'
        modalWrapperClassName={cx(styles['modal-wrapper'])}
      >
        <div className={cx(styles['container'], className)}>
          {icon ? icon : <Loading size='xlarge' />}
          {typeof text === 'string' ? (
            <div className={styles['text']}>{text}</div>
          ) : (
            text
          )}
        </div>
      </Modal>
    );
  }
);
LoadingModal.displayName = 'LoadingModal';
